export const animationCloseMessages = {
  en: {
    close: 'Close',
  },
};
